export const offersConstants = {
  GET_LIST_START: 'OFFERS_GET_LIST_START',
  GET_LIST_SUCCESS: 'OFFERS_GET_LIST_SUCCESS',
  GET_LIST_FAILURE: 'OFFERS_GET_LIST_FAILURE',

  SET_OFFERS_CATALOG_FILTER: 'SET_OFFERS_CATALOG_FILTER',

  SET_OFFER_REQUEST: 'SET_OFFER_REQUEST',
  SET_OFFER_SUCCESS: 'SET_OFFER_SUCCESS',
  SET_OFFER_FAILURE: 'SET_OFFER_FAILURE',

  SET_OFFER_NEWS_REQUEST: 'SET_OFFER_NEWS_REQUEST',
  SET_OFFER_NEWS_SUCCESS: 'SET_OFFER_NEWS_SUCCESS',
  SET_OFFER_NEWS_FAILURE: 'SET_OFFER_NEWS_FAILURE',

  SET_OFFERS_TABS_SUCCESS: 'SET_OFFERS_TABS_SUCCESS',
  SET_OFFERS_TABS_FAILURE: 'SET_OFFERS_TABS_FAILURE',

  SET_OFFERS_FILTERS_SUCCESS: 'SET_OFFERS_FILTERS_SUCCESS',
  SET_OFFERS_FILTERS_FAILURE: 'SET_OFFERS_FILTERS_FAILURE',
};
